import en from './en_US.json'
import ar from './ar_SA.json'

const DEFAULT_LOCALE_MESSAGE = ar

const getMessagesByLocale = (locale) => {
  if (!locale) {
    return DEFAULT_LOCALE_MESSAGE
  }

  const [lang] = locale.replace('-', '_').split('_')
  const messages = {
    en,
    ar,
  }[lang]

  // return default to ar-SA
  return messages || DEFAULT_LOCALE_MESSAGE
}

export default { en, ar }
export { getMessagesByLocale }
